import React from 'react';
import PropTypes from 'prop-types';
import Dot from 'components/dot';
import {isActive} from 'utils/interaction-util';
import {getColumnCenterX, getColumnY} from 'utils/layout-util';
import {isValid} from 'validators/number-validator';
import styles from './index.css';

export default class DotSeries extends React.Component {
  static propTypes = {
    activeIndex: PropTypes.number,
    data: PropTypes.array,
    interactive: PropTypes.bool,
    scaleY: PropTypes.func,
    style: PropTypes.object,
    tickWidth: PropTypes.number,
    transform: PropTypes.string,
  };

  static defaultProps = {
    activeIndex: -1,
    data: [],
    interactive: true,
    scaleY: () => {},
    style: {},
    tickWidth: 0,
    transform: '',
  };

  render() {
    const {
      activeIndex,
      data,
      interactive,
      scaleY,
      style,
      tickWidth,
      transform,
    } = this.props;
    return (
      <g className={styles.DotSeries} style={style} transform={transform}>
        {data.map((datum, index) => {
          const active = isActive(activeIndex, index, interactive);
          const x = getColumnCenterX(tickWidth, index);
          const y = getColumnY(scaleY, datum.value);
          return isValid(datum.value) ? (
            <Dot
              active={active}
              className={datum.className}
              key={`column-${index}`}
              style={datum.style || style}
              tickWidth={tickWidth}
              value={datum.value}
              x={x}
              y={y}
            />
          ) : null;
        })}
      </g>
    );
  }
}
